<!-- <app-navbar-style-one></app-navbar-style-one> -->

<div class="inner-banner inner-bg10">
    <div class="container">
        <div class="inner-title text-center">
            <h3>ملفي الشخصي</h3>
        </div>
    </div>
</div>
<div class="alert alert-success text-center" *ngIf="showSuccess" style="position: fixed;top: 20%;direction: ltr;left: 50%;transform: translate(-50%, -50%);z-index: 99999999999999;">
    {{successMsg}}
</div>

<div class="alert alert-danger text-center" *ngIf="showError" style="position: fixed;top: 20%;direction: ltr;left: 50%;transform: translate(-50%, -50%);z-index: 99999999999999;">
    {{errorMsg}}
</div>
<section class="checkout-area pt-100 pb-70" dir="rtl">
    <div class="container">
        <div class="profile-container">
            <!-- Profile Header with Avatar -->
            <div class="profile-header">
                <!-- <p>{{profileImage}}</p> -->
                <div class="avatar-container">
                    <img [src]="profileImage || './assets/img/default-avatar.jpg'" 
                         class="profile-avatar"
                         (error)="handleImageError($event)"
                         #avatarPreview>
                    <span>
                      <label style="position: absolute;transform: translate(0, 0);bottom: 0;left: 15%;" for="changeImage">
                        <i class="fa fa-camera"></i>
                      </label>
                      <input type="file" id="changeImage" hidden 
                        accept="image/png, image/jpg, image/jpeg" 
                        (change)="onFileSelected($event)" #fileInput>
                    </span>

                    <span>
                        <label style="position: absolute;transform: translate(0, 0);bottom: 0;right: 15%;" (click)="removeProfileImage()">
                          <i class="fa fa-trash"></i>
                        </label>
                      </span>
                </div>
                <h2 class="profile-name">{{userData?.name}}</h2>
                <p class="profile-location">
                    <i class="fas fa-map-marker-alt"></i> {{userData?.city}}, {{userData?.country}}
                </p>
            </div>

            <!-- Profile Form -->
            <form class="profile-form contact-form" [formGroup]="profileForm">
                <!-- Name Field -->
                <div class="form-group">
                    <label for="name">الاسم الكامل</label>
                    <input class="form-control" type="text" id="name" formControlName="name">
                </div>

                <!-- Phone Field -->
                <div class="form-group">
                    <label for="phone">رقم الهاتف الرئيسي</label>
                    <input class="form-control" type="tel" id="phone" formControlName="phone">
                </div>

                <!-- Secondary Phone Field -->
                <div class="form-group">
                    <label for="secPhone">رقم هاتف إضافي (اختياري)</label>
                    <input class="form-control" type="tel" id="secPhone" formControlName="secPhone">
                </div>

                <!-- Gender Field -->
                <div class="form-group">
                    <label>الجنس</label>
                    <div class="gender-options">
                        <label>
                            <input type="radio" formControlName="gender" value="male"> ذكر
                        </label>
                        <label>
                            <input type="radio" formControlName="gender" value="female"> أنثى
                        </label>
                    </div>
                </div>

                <!-- Non-editable Fields -->
                <div class="form-group readonly">
                    <label>البريد الإلكتروني</label>
                    <p>{{userData?.email}}</p>
                </div>

                <div class="form-group readonly">
                    <label>اسم المستخدم</label>
                    <p>{{userData?.username}}</p>
                </div>

                <div class="form-group readonly">
                    <label>كلمة المرور
                        <button type="button" class="default-btn default-hot-toddy" 
                        id="openModalChangePass" data-bs-toggle="modal" data-bs-target="#changePass">
                            تغيير كلمة المرور
                        </button>
                    </label>
                    <!-- <p> -->
                        
                    <!-- </p> -->
                </div>

                <!-- <div class="form-group readonly">
                    <label>اللغة</label>
                    <p>{{userData?.lang === 'en' ? 'English' : 'العربية'}}</p>
                </div> -->

                <!-- Save Button -->
                <div class="form-actions text-center">
                    <button type="button" class="default-btn default-hot-toddy" (click)="saveProfile()" [disabled]="isLoading || profileForm.invalid">
                        حفظ التغييرات
                    </button>
                </div>
            </form>
        </div>
    </div>
    <div class="container mt-2">
        <div class="profile-container">
            <h3>حذف الحساب الشخصي</h3>
            <p class="px-4 py-2">قم بإزالة حسابك الشخصي وجميع محتوياته من منصة وصلة بشكل دائم. هذا الإجراء غير قابل للتراجع، لذا يرجى الاستمرار بحذر.</p>
            <div class="text-center">
                <div class="form-actions text-center">
                    <button type="button" class="default-btn default-hot-toddy" 
                        style="background-color: rgb(206, 0, 0);"
                        id="openModal" data-bs-toggle="modal" data-bs-target="#staticBackdrop">
                        حذف الحساب
                    </button>
                </div>
            </div>
        </div>
    </div>

    <div class="modal fade" id="staticBackdrop" data-bs-backdrop="static" data-bs-keyboard="false" tabindex="-1" aria-labelledby="staticBackdropLabel" aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title" id="staticBackdropLabel">تأكيد حذف الحساب</h5>
                    <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                </div>
                <div class="modal-body text-center">
                    <i class="fa-solid fa-triangle-exclamation"></i>
                    <p class="signInFirst">
                        هل أنت متاكد من حذف الحساب, لن تستطيع فتح حسابك مره اخري!!
                    </p>
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">الغاء</button>
                    <a href="login-register" (click)="removeProfile()" type="button" class="btn btn-primary">حذف</a>
                </div>
            </div>
        </div>
    </div>

    <div class="modal fade" id="changePass" data-bs-backdrop="static" data-bs-keyboard="false" tabindex="-1" aria-labelledby="changePassLabel" aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title" id="changePassLabel">تغيير كلمة المرور</h5>
                    <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                </div>
                <div class="modal-body">
                    <form class="contact-form" [formGroup]="changePasswordForm">
                        <div class="row">
                            <div class="col-12">
                                <label class="form-label">كلمة المرور القديمة</label>
                                <div class="form-group">
                                    <i class='bx bx-lock-alt'></i>
                                    <input class="form-control" type="password" name="old_password" formControlName="old_password" placeholder="كلمة المرور القديمة">
                                    <div *ngIf="f['old_password'].touched && f['old_password'].invalid" class="error-msg text-start">
                                        <div *ngIf="f['old_password'].hasError('required')">كلمة المرور القديمة مطلوبة</div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-12">
                                <label class="form-label">كلمة المرور الجديده</label>
                                <div class="form-group">
                                    <i class='bx bx-lock-alt'></i>
                                    <input class="form-control" type="password" name="new_password" formControlName="new_password" placeholder="كلمة المرور الجديده">
                                    <div *ngIf="f['new_password'].touched && f['new_password'].invalid" class="error-msg text-start">
                                        <div *ngIf="f['new_password'].hasError('required')">كلمة المرور الجديده مطلوبة</div>
                                        <div *ngIf="f['new_password'].hasError('minLength')">كلمة المرور يجب ان تكون اطول من 8 احرف</div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-12">
                                <label class="form-label">تأكيد كلمة المرور</label>
                                <div class="form-group">
                                    <i class='bx bx-lock-alt'></i>
                                    <input class="form-control" type="password" id="confirmPass" name="new_password_confirmation" formControlName="new_password_confirmation" placeholder="تأكيد كلمة المرور">
                                    <div *ngIf="f['new_password_confirmation'].touched && f['new_password_confirmation'].invalid" class="error-msg text-start">
                                        <div *ngIf="f['new_password_confirmation'].hasError('required')">كلمة المرور مطلوبة</div>
                                        <div *ngIf="f['new_password_confirmation'].hasError('minLength')">كلمة المرور يجب ان تكون اطول من 8 احرف</div>
                                        <div *ngIf="f['new_password_confirmation'].hasError('mismatch')">كلمة المرور يجب ان تكون مماثلة لكلمة المرور السابقة</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </form>
                    <!-- <i class="fa-solid fa-triangle-exclamation"></i>
                    <p class="signInFirst">
                        هل أنت متاكد من حذف الحساب, لن تستطيع فتح حسابك مره اخري!!
                    </p> -->
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">الغاء</button>
                    <a (click)="changePassword()" type="button" class="btn btn-primary">تغيير</a>
                </div>
            </div>
        </div>
    </div>
</section>

<!-- <app-footer-style-two></app-footer-style-two> -->